/* eslint-disable @typescript-eslint/no-floating-promises */
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { getClassNames } from '@helpers/productWidgetHelper'
import ProductHealthInfoCards from './ProductHealthInfoCard/ProductHealthInfoCard'
import KeyFeatures from '../keyFeatures'
import { ABHA_WIDGET, TAP_BTN_EVENT, FUNNEL_TYPE } from '../constants'
import { ProductKeyFeaturesAndCtaProps } from './productInterfaces'
import styles from '../productWidget.module.scss'

const ProductKeyFeaturesAndCta: React.FC<ProductKeyFeaturesAndCtaProps> = ({
  content,
  isMobileView,
  isAutoWidgetLayout,
  isSeoCarWidget,
  THEME_CONFIG,
  segmentEventCommonProperties,
  renderCtaButton,
  isHealthWidgetPurpleLayout = false,
  hideSection = false,
  getCtaWidgetPurpleLayout = false,
}) => {
  const handleButtonClick = () => {
    ;(async () => {
      await trackEvent(TAP_BTN_EVENT, {
        ...segmentEventCommonProperties,
        funnel: FUNNEL_TYPE.ENGAGE,
        source: content?.cta?.name,
      })
      window.location.href = content?.cta?.link
    })()
  }

  const desktopMwebContainerClassNames = getClassNames([], {
    [styles.semLayoutKeyFeaturesMobile]: isMobileView,
    [styles.semLayoutKeyFeaturesDesktopContainer]: !isMobileView && isAutoWidgetLayout,
    [styles.seoDontRenderContent]: isHealthWidgetPurpleLayout || getCtaWidgetPurpleLayout,
  })
  const marginRequired = isMobileView || isAutoWidgetLayout

  return (
    <>
      {!isSeoCarWidget && content?.KeyFeatures && (
        <div className={desktopMwebContainerClassNames}>
          <KeyFeatures
            keyFeaturesData={content.KeyFeatures}
            isMarginRequired={marginRequired}
            themeClassname={THEME_CONFIG[content?.theme]}
          />
        </div>
      )}

      {isHealthWidgetPurpleLayout && !hideSection && (
        <ProductHealthInfoCards isMobile isHealthWidgetLayout widget={ABHA_WIDGET} />
      )}

      {renderCtaButton && content?.cta?.name && (
        <div className={styles.ctaButton} onClick={handleButtonClick}>
          {content?.cta?.name}
        </div>
      )}
    </>
  )
}

export default ProductKeyFeaturesAndCta
